"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupportedDomain = void 0;
const enums_1 = require("./enums");
const expressions_1 = require("./expressions");
/**
 * Validates that a url string is from a valid domain.
 */
const isValidDomain = (input) => {
    if (!exports.isSupportedDomain(input)) {
        return false;
    }
    // Get type of url
    const type = input.match(`(${Object.values(enums_1.ALL_SOCIALS).join('|')})`)[0];
    // Validate w/ specific validator
    switch (type) {
        // All of these domain follow the same standard URL pattern
        case enums_1.ALL_SOCIALS.FACEBOOK:
            return isValidFacebook(input);
        case enums_1.ALL_SOCIALS.INSTAGRAM:
            return isValidInstagram(input);
        case enums_1.ALL_SOCIALS.TWITTER:
            return isValidTwitter(input);
        case enums_1.ALL_SOCIALS.SOUNDCLOUD:
            return isValidSoundcloud(input);
        case enums_1.ALL_SOCIALS.YOUTUBE:
            return isValidYoutube(input);
        case enums_1.ALL_SOCIALS.SPOTIFY:
            return isValidSpotify(input);
        default:
            return false;
    }
};
const isSupportedDomain = (input) => {
    const supportedDomainRegex = new RegExp(expressions_1.allSupportedDomains, 'gmi');
    if (supportedDomainRegex.exec(input) !== null) {
        return true;
    }
    return false;
};
exports.isSupportedDomain = isSupportedDomain;
const isValidFacebook = (url) => {
    const validFacebookUrl = new RegExp(`^${expressions_1.optionalProtocol}${expressions_1.optionalWWW}(facebook.com\/)([A-Za-z0-9_.]{1,})$`, 'i');
    return validFacebookUrl.test(url);
};
const isValidInstagram = (url) => {
    const validInstagramUrl = new RegExp(`^${expressions_1.optionalProtocol}${expressions_1.optionalWWW}(instagram.com\/)([A-Za-z0-9_.]{1,})$`, 'i');
    return validInstagramUrl.test(url);
};
const isValidTwitter = (url) => {
    const validTwitterUrl = new RegExp(`^${expressions_1.optionalProtocol}${expressions_1.optionalWWW}(twitter.com\/)([A-Za-z0-9_]{1,})$`, 'i');
    return validTwitterUrl.test(url);
};
const isValidSoundcloud = (url) => {
    const validSoundcloudUrl = new RegExp(`^${expressions_1.optionalProtocol}${expressions_1.optionalWWW}(soundcloud.com\/)([A-Za-z0-9_.-]{1,})$`, 'i');
    return validSoundcloudUrl.test(url);
};
const isValidYoutube = (url) => {
    const validYoutubeUrl = new RegExp(`^${expressions_1.optionalProtocol}${expressions_1.optionalWWW}${expressions_1.youtubeSocialPrefix}([\\w-])+$`, 'i');
    return validYoutubeUrl.test(url);
};
const isValidSpotify = (url) => {
    const validSpotifyUrl = new RegExp(`^(${expressions_1.optionalProtocol}${expressions_1.strictSpotifyPrefix}(${expressions_1.validSpotifyId}))|(${expressions_1.optionalProtocol}((open.|play.)spotify.com/user/)(\\w+))$`, 'i');
    return validSpotifyUrl.test(url);
};
exports.default = isValidDomain;
//# sourceMappingURL=isValidDomain.js.map